import { renderIcon } from "discourse-common/lib/icon-library";
export function iconNode(id, params) {
  return renderIcon("node", id, params);
}